import React from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "./Modal.css";
function Modal() {
  return (
    <Popup
      trigger={
        <button className="help-btn border-b-2 border-emerald-100  hover:border-slate-900 transition ">
          {" "}
          Help
        </button>
      }
      modal
      nested
    >
      {(close) => (
        <div className="modal">
          <button className="close" onClick={close}>
            &times;
          </button>
          <div className="header"> Help </div>
          <div className="modal-item">
            <div className="header">About</div>{" "}
            <div className="content">
              This website offers a quick and easy way to create a
              professional-looking resume.
            </div>
          </div>
          <div className="modal-item">
            <div className="header">How to use</div>{" "}
            <div className="content">
              Enter your info->preview the changes in real time->download as PDF
            </div>
          </div>{" "}
          <div className="modal-item">
            <div className="header">How to save</div>{" "}
            <div className="content">
              Your information is automatically saved on your device for future
              visits to the site, except when using incognito mode.
            </div>
          </div>{" "}
          <div className="modal-item">
            <div className="header">How it structured</div>{" "}
            <div className="content">
              You are free to add or remove items based on your preferences.
              Here's a summary of each component:
            </div>
            <div className="content">
              <ul>
                <li className="pl-4 ">
                  -Left column:{" "}
                  <ul>
                    <li className="pl-4">
                      -Info element: For education/awards/certifications/event
                      participation.{" "}
                    </li>
                    <li className="pl-4">
                      -List element: For software expertise, soft skills,
                      languages, hobbies, and interests. There's an option to
                      display your proficiency level.
                    </li>
                  </ul>
                </li>
                <li className="pl-4">
                  {" "}
                  -Right column
                  <ul>
                    <li className="pl-4">
                      {" "}
                      -Experience element: For previous
                      jobs/internships/projects. You are free to describe them
                      in paragraph, list or combination of both{" "}
                    </li>
                    <li className="pl-4">-Reference element: For reference </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="content"> </div>
          </div>{" "}
          <div className="modal-item">
            <div className="header">About privacy</div>{" "}
            <div className="content">
              All of the processes for creating and saving your information are
              done on your device, and no data is transmitted to the server.
            </div>
          </div>
        </div>
      )}
    </Popup>
  );
}

export default Modal;
